<template>
  <div :id="genericPopupId" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header generic-header">
          <template>
            <span class="col-md-12 pt-10">{{ genericHeader }}</span>
          </template>
        </div>
        <div class="modal-body generic-body">
          <div class="col-md-12 p-10" v-if="genericBody">
            <div>
              <p>
                Your account is currently limited to a maximum of
                {{ isREP ? this.max_number - 1 : this.max_number }}
                <template v-if="genericBody === 'upgradeTeams'">members.</template>
                <template v-if="genericBody === 'upgradeRecords'">records.</template>
              </p>
              <p class="inlineStyle">
                Please
                <span class="rams_url cursor-pointer" @click="upgrade">Click here</span> if you
                would like to upgrade your account.
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="clear: both">
          <button type="button" class="btn emergo-green-button" @click="closePopupOnOk">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    genericPopupId: String,
    genericHeader: String,
    genericBody: String,
    emitUpgradeRecords: Function,
    emitUpgradeTeams: Function,
    max_number: Number,
    isREP: Boolean
  },
  data() {
    return {};
  },
  methods: {
    closePopupOnOk() {
      $(`#${this.genericPopupId}`).modal('hide');
    },
    async upgrade() {
      if (this.genericBody === 'upgradeRecords') {
        setTimeout(() => {
          $(`#${this.genericPopupId}`).modal('hide');
        }, 200);
        this.$emit('emitUpgradeRecords');
      } else if (this.genericBody === 'upgradeTeams') {
        setTimeout(() => {
          $(`#${this.genericPopupId}`).modal('hide');
        }, 200);
        this.$emit('emitUpgradeTeams');
      }
    }
  },
  watch: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.modal-lg {
  width: 50%;
}
.generic-header {
  font-weight: $font-weight-600;
  text-align: center;
  font-size: $font-22;
}
.generic-body {
  padding: 20px 0px 10px;
  text-align: center;
  color: $black-alpha;
  font-style: normal;
  @include fontItems($font-16, 16px, $font-weight-400);
}
.rams_url {
  color: $light-thick-blue;
}
.inlineStyle {
  display: inline;
}
.a-link {
  font-size: $font-20;
  color: $primary;
}
</style>
